export default __webpack_public_path__ + "static/media/pattern2.1577e5f2.png";